module.exports = __webpack_public_path__ + "static/media/motic wireframe2.06f5a4c1.png";